import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spacer } from "../../ui/components/Spacer.js";
import { Spinner } from "../../ui/components/Spinner.js";
import { Container } from "../../ui/components/basic.js";
import { Text } from "../../ui/components/text.js";
export function LoadingState(props) {
    return (_jsxs(Container, { animate: "fadein", children: [_jsx(Spacer, { y: "xxl" }), _jsxs(Container, { flex: "row", center: "x", style: {
                    position: "relative",
                }, children: [_jsx(Spinner, { size: "4xl", color: "accentText" }), _jsx(Container, { color: "accentText", style: {
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                        }, children: props.icon })] }), _jsx(Spacer, { y: "xl" }), _jsx(Text, { center: true, color: "primaryText", size: "lg", children: props.title }), _jsx(Spacer, { y: "md" }), _jsx(Text, { multiline: true, center: true, children: props.subtitle }), _jsx(Spacer, { y: "xxl" }), _jsx(Spacer, { y: "xxl" })] }));
}
//# sourceMappingURL=LoadingState.js.map